module.exports = __webpack_public_path__ + "static/media/ages.b86390e0.png";